import React from 'react'
import { Form, Container, Table, TableRow, TableBody, TableCell, TableHeader, TableHeaderCell} from 'semantic-ui-react'
import { useFormik } from 'formik'
import { initialValues, validationSchema2 } from './OpeForm.form'
import { DZ } from '../../../../../api'
import { useAuth } from '../../../../../hooks'
import "./OpeForm.scss";

const DZController = new DZ();

export function OpeDZForm2(props) {
    const { onClose, onReload, DZ } = props;
    const { accessToken } = useAuth();

    const formik = useFormik({
        initialValues: initialValues(DZ),
        validationSchema: validationSchema2(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            try {
                const data = {
                  preciounitario : formValue.preciounitario,
                  presentacion : DZ.presentacion,
                }
                if (!DZ) {
                    console.log("no deberia de pasar")
                   
                    // await equalController.createDZ(accessToken, data);
                } else {
                    await DZController.UpdateOpe(accessToken, DZ._id, data);
                }
                onClose();
                onReload();
            } catch (error) {
                console.error(error);
            }
        }
    });

    
    const handleSave = async () => {
        try {
            const data = {
                preciounitario : formik.values.preciounitario
            }
            console.log(formik.values.preciounitario);
            await DZController.saveDZOpe(accessToken, DZ._id, data)
            onClose();
            onReload();
            } catch (error) {
            console.error(error);
        }
    }
    return (
        <Form onSubmit={formik.handleSubmit} className='form'>
            <Container className='cotizacion-principal_info'>
              <p>Asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesornom}</span></p>
              <p>Correo asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesor}</span></p>
              <br></br>
              <p>Nombre del producto:<span className='cotizacion-principal_info-dxp'>{DZ.nombre}</span></p>
              <p>Familia del producto:<span className='cotizacion-principal_info-dxp'>{DZ.familia}</span></p>
              <p>Activos: <span className='cotizacion-principal_info-dxp'>{DZ.activos}</span></p>
              <p>Base: <span className='cotizacion-principal_info-base'>{DZ.base}</span></p>
              <p>Presentación: <span className='cotizacion-principal_info-activos'>{DZ.presentacion}</span></p>
              <p>Envase: <span className='cotizacion-principal_info-activos'>{DZ.envase}</span></p>
              <p>Área: <span className='cotizacion-principal_info-dxp'>{DZ.area}</span></p>
              {(DZ.sIyD && DZ.caducidad) && <p>Caducidad: <span className='cotizacion-principal_info-nombre'>{DZ.caducidad}</span></p>}
              <br></br>
              <p>Genero del paciente: <span className='cotizacion-principal_info-base'>{DZ.genero}</span></p>
              <p>Rango de edad: <span className='cotizacion-principal_info-dxp'>{DZ.rangoedad}</span></p>
              <p>Tipo de piel: <span className='cotizacion-principal_info-dxp'>{DZ.tipopiel}</span></p>
              <p>Padecimiento: <span className='cotizacion-principal_info-dxp'>{DZ.padecimiento}</span></p>

              <br></br>
              <p>Precio Objetivo: <span className='cotizacion-principal_info-activos'>{DZ.objetivo}</span></p>
              {DZ.motivo && <p>Motivo de cancelación: <span className='cotizacion-principal_info-nombre'>{DZ.motivo}</span></p>}
              {DZ.presupuesto && <p>Presupuesto de InyDe: <span className='cotizacion-principal_info-nombre'>{DZ.presupuesto}</span></p>}
            </Container>
        <Container className='precio_unitario'>
                <Table className='table-precio' celled>
                    <TableHeader>
                        <TableRow>
                        <TableHeaderCell></TableHeaderCell>
                        <TableHeaderCell>Presupuesto</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow>
                        <TableCell>KG</TableCell>
                        <TableCell>{DZ.presupuesto}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Container>
            <br></br>
            {DZ.sIyD && (
              <Container className='precio_unitario'>
                <Table className='table-precio' celled>
                    <TableHeader>
                        <TableRow>
                        <TableHeaderCell></TableHeaderCell>
                        <TableHeaderCell>Presupuesto Logrado</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow>
                        <TableCell>KG</TableCell>
                        <TableCell>{DZ.costologrado}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Container>
          )}
            <br></br>
            <Container className='precio_unitario'>
                <Table className='table-precio' celled>
                    <TableHeader>
                        <TableRow>
                        <TableHeaderCell>Presentacion</TableHeaderCell>
                        <TableHeaderCell>Precio Unitario</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow>
                        <TableCell>{DZ.presentacion} ml</TableCell>
                        <TableCell><Form.Input name='preciounitario' placeholder='0' onChange={(e) => {formik.setFieldValue('preciounitario', e.target.value.replace(/[^0-9]/g, ''))}} value={formik.values.preciounitario} error={formik.errors.preciounitario} /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Container>
            <br></br>
            <Form.Button type='button' primary fluid onClick={handleSave} loading={formik.isSubmitting}>
                Guardar
            </Form.Button>
            <Form.Button type='submit' primary fluid loading={formik.isSubmitting}>
                Aceptar
            </Form.Button>
        </Form>
    )
}
